import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { OrderDetails } from "@/components/order-details";
import { useGetOrder } from "@/hooks/api/order/useGetOrder";
import { useAuthStore } from "@/stores/authStore";

const OrderDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  const { data, isLoading, isError } = useGetOrder(id || "");

  return (
    <OrderDetails
      data={data}
      handleNavigate={navigate}
      isError={isError}
      isLoading={isLoading}
    />
  );
};

export default OrderDetailsPage;
